"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ifDefined = exports.isPlainObject = exports.isNumber = exports.isDefined = void 0;
/**
 * checks if a thing is defined. while often easy to do with a simple if statement, in certain
 * situations the guard is required and its nice to have one pre-defined. E.g. in the following
 * example, the result is `Array<string>`.
 *
 * `const result = (array as Array<string | undefined>).filter(isDefined);`
 */
const isDefined = (x) => x !== undefined;
exports.isDefined = isDefined;
/**
 * checks if a thing is a number. while often easy to do with a simple if statement, in certain
 * situations the guard is required and its nice to have one pre-defined. E.g. in the following
 * example, the result is `Array<number>`.
 *
 * `const result = (array as Array<number | undefined>).filter(isNumber);`
 */
const isNumber = (x) => typeof x === 'number';
exports.isNumber = isNumber;
/**
 * a guard for plain old javascript objects that are not based on some other prototype,
 * for example making them safe to JSON stringify and stuff
 */
const isPlainObject = (thing) => thing instanceof Object && thing.__proto__.constructor.name === 'Object';
exports.isPlainObject = isPlainObject;
/**
 * if the first thing is defined it uses it, otherwise it returns the second thing. this isn't
 * really a guard its just a way to provide a default value without creating a coverage branch.
 *
 * @example const valueWithDefault = ifDefined(thing, 'default value')
 */
const ifDefined = (x, d) => (0, exports.isDefined)(x) ? x : d;
exports.ifDefined = ifDefined;
